import {IMeshCellValueFormat} from "@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/cellFormat/valueFormat/ValueFormat";
import {MeshCellValueFormatKind} from "@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/cellFormat/valueFormat/ValueFormatKind";
import {IValue} from "@mintdata/mint-kit/api/types/Value";
import {IMeshCellSettings} from "@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/MeshCellSettings";

export class MeshCellImageValueFormat implements IMeshCellValueFormat
{
    static Default:MeshCellImageValueFormat = new MeshCellImageValueFormat();

    public readonly kind:MeshCellValueFormatKind = MeshCellValueFormatKind.Image;
    public readonly formatString = "General";
    public readonly id:string = 'Image';

    static deserialize(valueFormat:any):MeshCellImageValueFormat | null
    {
        return new MeshCellImageValueFormat();
    }

    formatCode():string
    {
        return 'G';
    }

    formatValue(slotValue: IValue): string {
        const value = slotValue ? slotValue.toString() : '';
        return /^http[s]?:\/\/.*/.test(value) ? value : `http://${value}`;
    }

    getTextColor(value: IValue, cellSettings: IMeshCellSettings): string {
        return "#000000";
    }

    digitsAfterPoint(): number {
        return 0;
    }

    isStringOfThisFormat(formattedValue:string):boolean
    {
        return false;
    }

    extractValue(formattedValue:string):any
    {
        return formattedValue;
    }
}
